/**
 * Serviço para comunicação com a API EAD através do backend SISCompliance
 * Todas as chamadas passam pelo proxy /api/ead
 */

import request from "@/utils/request";

// ==================== CURSOS ====================

/**
 * Listar todos os cursos (filtrado automaticamente por empresa no backend)
 */
export function getCourses(params) {
  return request({
    url: "/ead/courses",
    method: "get",
    params,
  });
}

/**
 * Buscar curso específico por ID
 */
export function getCourse(id) {
  return request({
    url: `/ead/courses/${id}`,
    method: "get",
  });
}

/**
 * Criar novo curso
 */
export function createCourse(data) {
  return request({
    url: "/ead/courses",
    method: "post",
    data,
  });
}

/**
 * Atualizar curso existente
 */
export function updateCourse(id, data) {
  return request({
    url: `/ead/courses/${id}`,
    method: "put",
    data,
  });
}

/**
 * Deletar curso
 */
export function deleteCourse(id) {
  return request({
    url: `/ead/courses/${id}`,
    method: "delete",
  });
}

// ==================== MÓDULOS ====================

/**
 * Listar módulos de um curso
 */
export function getModules(courseId) {
  return request({
    url: `/ead/modules/course/${courseId}`,
    method: "get",
  });
}

/**
 * Criar novo módulo
 */
export function createModule(data) {
  return request({
    url: "/ead/modules",
    method: "post",
    data,
  });
}

/**
 * Atualizar módulo
 */
export function updateModule(id, data) {
  return request({
    url: `/ead/modules/${id}`,
    method: "put",
    data,
  });
}

/**
 * Deletar módulo
 */
export function deleteModule(id) {
  return request({
    url: `/ead/modules/${id}`,
    method: "delete",
  });
}

// ==================== CONTEÚDOS ====================

/**
 * Listar conteúdos de um módulo
 */
export function getContents(moduleId) {
  return request({
    url: `/ead/contents/module/${moduleId}`,
    method: "get",
  });
}

/**
 * Criar novo conteúdo
 */
export function createContent(data) {
  return request({
    url: "/ead/contents",
    method: "post",
    data,
  });
}

/**
 * Atualizar conteúdo
 */
export function updateContent(id, data) {
  return request({
    url: `/ead/contents/${id}`,
    method: "put",
    data,
  });
}

/**
 * Deletar conteúdo
 */
export function deleteContent(id) {
  return request({
    url: `/ead/contents/${id}`,
    method: "delete",
  });
}

// ==================== TURMAS ====================

/**
 * Listar turmas
 */
export function getClasses(params) {
  return request({
    url: "/ead/classes",
    method: "get",
    params,
  });
}

/**
 * Buscar turma por ID
 */
export function getClass(id) {
  return request({
    url: `/ead/classes/${id}`,
    method: "get",
  });
}

/**
 * Criar turma
 */
export function createClass(data) {
  return request({
    url: "/ead/classes",
    method: "post",
    data,
  });
}

/**
 * Atualizar turma
 */
export function updateClass(id, data) {
  return request({
    url: `/ead/classes/${id}`,
    method: "put",
    data,
  });
}

/**
 * Excluir turma
 */
export function deleteClass(id) {
  return request({
    url: `/ead/classes/${id}`,
    method: "delete",
  });
}

/**
 * Adicionar alunos à turma
 */
export function addStudentsToClass(id, data) {
  return request({
    url: `/ead/classes/${id}/students`,
    method: "post",
    data,
  });
}

/**
 * Remover aluno da turma
 */
export function removeStudentFromClass(classId, studentId) {
  return request({
    url: `/ead/classes/${classId}/students/${studentId}`,
    method: "delete",
  });
}

// ==================== USUÁRIOS ====================

/**
 * Listar usuários EAD
 */
export function getEadUsers(params) {
  return request({
    url: "/ead/users",
    method: "get",
    params,
  });
}

/**
 * Criar usuário EAD
 */
export function createEadUser(data) {
  return request({
    url: "/ead/users",
    method: "post",
    data,
  });
}

// ==================== MATRÍCULAS ====================

/**
 * Matricular aluno em curso
 */
export function enrollStudent(data) {
  return request({
    url: "/ead/enrollments",
    method: "post",
    data,
  });
}

/**
 * Listar matrículas
 */
export function getEnrollments(params) {
  return request({
    url: "/ead/enrollments",
    method: "get",
    params,
  });
}

// ==================== PROVAS ====================

/**
 * Listar todas as provas
 */
export function getAllExams() {
  return request({
    url: "/ead/exams",
    method: "get",
  });
}

/**
 * Listar provas de um curso
 */
export function getExams(courseId) {
  return request({
    url: `/ead/exams/course/${courseId}`,
    method: "get",
  });
}

/**
 * Criar prova
 */
export function createExam(data) {
  return request({
    url: "/ead/exams",
    method: "post",
    data,
  });
}

/**
 * Atualizar prova
 */
export function updateExam(id, data) {
  return request({
    url: `/ead/exams/${id}`,
    method: "put",
    data,
  });
}

/**
 * Buscar prova por ID
 */
export function getExam(id) {
  return request({
    url: `/ead/exams/${id}`,
    method: "get",
  });
}

/**
 * Deletar prova
 */
export function deleteExam(id) {
  return request({
    url: `/ead/exams/${id}`,
    method: "delete",
  });
}

// ==================== QUIZZES ====================

/**
 * Listar todos os quizzes
 */
export function getAllQuizzes() {
  return request({
    url: "/ead/quizzes",
    method: "get",
  });
}

/**
 * Listar quizzes de um módulo
 */
export function getQuizzes(moduleId) {
  return request({
    url: `/ead/quizzes/module/${moduleId}`,
    method: "get",
  });
}

/**
 * Criar quiz
 */
export function createQuiz(data) {
  return request({
    url: "/ead/quizzes",
    method: "post",
    data,
  });
}

/**
 * Buscar quiz por ID
 */
export function getQuiz(id) {
  return request({
    url: `/ead/quizzes/${id}`,
    method: "get",
  });
}

/**
 * Atualizar quiz
 */
export function updateQuiz(id, data) {
  return request({
    url: `/ead/quizzes/${id}`,
    method: "put",
    data,
  });
}

/**
 * Deletar quiz
 */
export function deleteQuiz(id) {
  return request({
    url: `/ead/quizzes/${id}`,
    method: "delete",
  });
}

// ==================== RELATÓRIOS ====================

/**
 * Relatório de progresso (legado)
 */
export function getProgressReport(params) {
  return request({
    url: "/ead/reports/progress",
    method: "get",
    params,
  });
}

/**
 * Relatório de conclusão (legado)
 */
export function getCompletionReport(params) {
  return request({
    url: "/ead/reports/completion",
    method: "get",
    params,
  });
}

// ==================== RELATÓRIOS DE DESEMPENHO ====================

/**
 * Taxa de conclusão por curso
 */
export function getCompletionByCourse(params) {
  return request({
    url: "/ead/reports/completion-by-course",
    method: "get",
    params,
  });
}

/**
 * Tempo médio de conclusão
 */
export function getAverageCompletionTime(params) {
  return request({
    url: "/ead/reports/average-completion-time",
    method: "get",
    params,
  });
}

/**
 * Taxa de aprovação/reprovação
 */
export function getApprovalRate(params) {
  return request({
    url: "/ead/reports/approval-rate",
    method: "get",
    params,
  });
}

/**
 * Notas médias por curso/módulo
 */
export function getAverageGrades(params) {
  return request({
    url: "/ead/reports/average-grades",
    method: "get",
    params,
  });
}

/**
 * Progresso individual detalhado
 */
export function getIndividualProgress(userId, params) {
  return request({
    url: `/ead/reports/individual-progress/${userId}`,
    method: "get",
    params,
  });
}

// ==================== RELATÓRIOS DE ENGAJAMENTO ====================

/**
 * Taxa de abandono
 */
export function getAbandonmentRate(params) {
  return request({
    url: "/ead/reports/abandonment-rate",
    method: "get",
    params,
  });
}

/**
 * Frequência de acesso
 */
export function getAccessFrequency(params) {
  return request({
    url: "/ead/reports/access-frequency",
    method: "get",
    params,
  });
}

/**
 * Materiais mais acessados
 */
export function getMostAccessedMaterials(params) {
  return request({
    url: "/ead/reports/most-accessed-materials",
    method: "get",
    params,
  });
}

/**
 * Horários de pico de acesso
 */
export function getPeakHours(params) {
  return request({
    url: "/ead/reports/peak-hours",
    method: "get",
    params,
  });
}

// ==================== RELATÓRIOS DE COMPLIANCE ====================

/**
 * Status de certificações
 */
export function getCertificationsStatus(params) {
  return request({
    url: "/ead/reports/certifications-status",
    method: "get",
    params,
  });
}

/**
 * Prazos críticos
 */
export function getCriticalDeadlines(params) {
  return request({
    url: "/ead/reports/critical-deadlines",
    method: "get",
    params,
  });
}

/**
 * Conformidade por empresa
 */
export function getComplianceByCompany() {
  return request({
    url: "/ead/reports/compliance-by-company",
    method: "get",
  });
}

/**
 * Alertas de não conformidade
 */
export function getNonComplianceAlerts(params) {
  return request({
    url: "/ead/reports/non-compliance-alerts",
    method: "get",
    params,
  });
}

// ==================== RELATÓRIOS GERENCIAIS ====================

/**
 * Dashboard executivo
 */
export function getExecutiveDashboard(params) {
  return request({
    url: "/ead/reports/executive-dashboard",
    method: "get",
    params,
  });
}

/**
 * Comparativo entre turmas
 */
export function getClassesComparison(params) {
  return request({
    url: "/ead/reports/classes-comparison",
    method: "get",
    params,
  });
}

// ==================== RELATÓRIOS DE QUALIDADE ====================

/**
 * Avaliações de satisfação
 */
export function getSatisfactionRatings(params) {
  return request({
    url: "/ead/reports/satisfaction-ratings",
    method: "get",
    params,
  });
}

/**
 * Pontos de dificuldade
 */
export function getDifficultyPoints(params) {
  return request({
    url: "/ead/reports/difficulty-points",
    method: "get",
    params,
  });
}

// ==================== MÉTRICAS AVANÇADAS ====================

/**
 * Curva de aprendizagem
 */
export function getLearningCurve(params) {
  return request({
    url: "/ead/reports/learning-curve",
    method: "get",
    params,
  });
}

/**
 * Padrões de abandono
 */
export function getAbandonmentPatterns(params) {
  return request({
    url: "/ead/reports/abandonment-patterns",
    method: "get",
    params,
  });
}

/**
 * Correlações
 */
export function getCorrelations(params) {
  return request({
    url: "/ead/reports/correlations",
    method: "get",
    params,
  });
}

// ==================== EXPORTAÇÕES ====================

/**
 * Relatório customizado
 */
export function getCustomReport(params) {
  return request({
    url: "/ead/reports/custom-report",
    method: "get",
    params,
  });
}

// ==================== CERTIFICADOS ====================

/**
 * Listar certificados
 */
export function getCertificates(params) {
  return request({
    url: "/ead/certificates",
    method: "get",
    params,
  });
}
